import { createBrowserRouter, Navigate } from "react-router-dom";
import ClientLandingPage from "../features/client/pages/ClientLandingPage";
import ServiceSelectionPage from "../features/client/pages/ServiceSelectionPage";
import BookingPage from "../features/client/pages/BookingPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <ClientLandingPage />,
  },
  {
    path: "/services",
    element: <ServiceSelectionPage />,
  },
  {
    path: "/book/:serviceId",
    element: <BookingPage />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

export default router;